import React from "react";
import { Link } from "gatsby";
import LOGO from "../images/logo_circle.png";
import { motion, useViewportScroll, useTransform } from "framer-motion";

const Header = () => {
  const { scrollYProgress } = useViewportScroll();
  const opacity = useTransform(scrollYProgress, [0, 0.2, 1], [1, 0.5, 0.5]);

  return (
    <motion.div
      style={{ opacity }}
      className="fixed top-0 w-full my-2 px-4 z-50"
    >
      <Link to="/">
        <div className="flex flex-row items-center">
          <img
            src={LOGO}
            className="w-10 h-10 object-contain object-center lg:h-16 lg:w-16"
            alt="logo"
          ></img>
          <span className="font-marvin text-xl tracking-wide text-black ml-2 lg:text-3xl lg:ml-3">
            Euph
            <span className="font-caprizant font-bold text-2xl px-1 text-gold">
              &
            </span>
            Tuba
            <span className="px-0.5"></span>Carnival
          </span>
        </div>
      </Link>
    </motion.div>
  );
};

export default Header;
